<template>
	<div> 
			<div class="success-modal-with-coupon modal fade" tabindex="-1" role="dialog" aria-labelledby="cancelPayModal" aria-hidden="true">
					<div class="modal-dialog modal-pdv">
							<div class="modal-content">
									<div class="modal-title">
											<!--button type="button" class="close" data-dismiss="modal" aria-label="Close">
													<span aria-hidden="true">&times;</span>
											</button-->
									</div>
									<div class="main-content">
											<div class="row">
													<div class="col-12 col-md-8 col-xl-9 text-content">
															<!--mg src="/images/iconos/waiticon.png" alt=""-->
															<div>
																	<h5>¡Estás a un clic de matricularte con nosotros!</h5>
																	<h6 class="mb-4">Tu reserva de cupos se ha realizado correctamente.</h6>
																	<div class="d-flex align-items-center message">
																			<!--img class="clock" src="/images/iconos/clock-yellow.png" alt=""-->
																			<span>
																					RECUERDA QUE LOS CUPOS SE MANTENDRÁN APARTADOS PARA TÍ SOLO DURANTE <b>5 MINUTOS</b>
																			</span>
																	</div>
																	<br/>
																	 <!--button 
																	type="button"
																	@click="onContinue"
																	class="btn-pdv-primary button">
																		Confirmar matrícula
																	</button-->
																	<div class="d-flex justify-content-center">
                                    <Button 
                                      title="Confirmar matrícula"
                                      type="primario"
                                      size="medium"
                                      @onClick="onContinue"
                                      data-dismiss="modal" aria-label="Close"
                                    />
                                  </div>
															</div>
													</div>
													<div class="col-12 col-md-4 col-xl-3 imagen-content">
														<img src="/images/featured/mask-group.svg" alt="mask-group" />
													</div>
											</div>
									</div>
								 
							</div>
					</div>
			</div>
	</div>

</template>

<script>
import Button from "@/components/featured/Button";
	export default {

			data(){
				return {

				}
			},
			components: {
				Button
			},

			methods:{
					onContinue(){
							this.$emit('onContinue')
					}
			}
	}
</script>

<style scoped lang="scss">
	.success-modal-with-coupon{
			@include media-breakpoint-down(sm){
					padding-right: 0 !important;
			}
			.modal-pdv{
					max-width: 951px;
					@include media-breakpoint-down(sm){
							margin: 65px 20px 0px 20px;
					}
					.modal-content{
						margin-top: 100px;
              border-radius: 24px;
                border: 2px solid $neutralBlack;
                background: $neutralwhite;
                padding: 24px;
							box-shadow: 0 0 12px 3px #00000038;
							@include media-breakpoint-down(sm){
									padding: 28px 25px;
							}
							h5 {
                  color: $neutralBlack;
                  text-align: center;
                  font-family: 'Poppins-Bold', sans-serif;
                  font-size: 32px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: 42px;
                }
                h6 {
                  color: $neutral80;
                  text-align: center;
                  font-family: 'Poppins-Regular', sans-serif;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 400;
                  line-height: 24px;
                }
							ul {
									margin-top: 5px;
									margin-bottom: 15px;
									li {
											color : #DC3545;
											font-weight: bold;
									}
							}
							.modal-title{
									button.close{
											position: absolute;
											right: 15px;
											top: 15px;
											opacity: 1;
											span{
													font-size: 30px;
													color: $brown-light;
											}
									}
							}
							.main-content{
									min-height: 350px;
									display: flex;
									align-items: center;
									h3{
											font-size: 20px;
											line-height: 23px;
											@include alternative-bold;
									}
									p {
											font-size: 18px;
											line-height: 26px;
											@include alternative-regular;
											margin-bottom: 19px;
									}
									.text-content {
											padding: 70px 10px 70px 70px;
											display: flex;
											align-items: center;
											img{
													margin-right: 30px;
													width: 203px;
											}
											img.clock{
													width: auto;
													margin-right: 6px;
													transform : scale(0.6)
											}
											span {
													font-size : 14px;
											}
											@include media-breakpoint-down(sm){
													display: block;
													text-align: center;
													img{
															margin-right: 0;
															margin-bottom: 18px;
															width: 146px;
													}
											}
									}
									.button {
											 @include media-breakpoint-up(sm){
													 width:160px;
											}
									}
							}

							.message{
                  padding: 12px 16px;
                  border-radius: 8px;
                  border: 1px solid #F1C469;
                  background: #FFFAF0;

                  span{
                    color: #966A11;
                    font-family: 'Poppins-Regular', sans-serif;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 22px; 
                  }
                }

                .imagen-content{
                  padding-top: 70px;
                }

					}

			}
	}

</style>